import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { Merchant } from '../shared/merchant.model';
import { MonitorService } from '../shared/monitor.service';
import { MonitorComponent } from './monitor.component';
import { NaturalezaContable } from '../bines/naturaleza-contable';
import { OperationStatus } from '../reportes/operation-status.model';
import { MonitorFilter } from '../shared/monitor.filter.model';

@Component({
  selector: 'pm-monitor-filter',
  templateUrl: './monitor-filter.component.html',
  styleUrls: ['./monitor-filter.component.sass']
})
export class MonitorFilterComponent implements OnInit, OnDestroy {
  // @Input() merchantSelected: any;
  // @Input() statusSelected: any;
  // @Input() accountingNature: any;
  @Input() incomingMonitorFilter: MonitorFilter;
  @Input() merchantList: Observable<Merchant[]>;
  @Input() accountingNatureList: Observable<NaturalezaContable[]>;
  @Input() operationStatusList: Observable<OperationStatus[]>;

  // @Output() txnMerchantSelected: EventEmitter<number>;
  // @Output() txnStatusSelected: EventEmitter<number>;
  // @Output() txnAccountingNature: EventEmitter<number>;
  @Output() txnMonitorFilter: EventEmitter<MonitorFilter>;

  constructor(public service: MonitorService, public parent: MonitorComponent) {
    this.txnMonitorFilter = new EventEmitter();
    // this.txnMerchantSelected = new EventEmitter();
    // this.txnStatusSelected = new EventEmitter();
    // this.txnAccountingNature = new EventEmitter();
  }

  ngOnInit() {
    console.log('ngOnInit: merchantId: ', this.incomingMonitorFilter.merchantId);
    console.log('ngOnInit: status: ', this.incomingMonitorFilter.status);
    console.log('ngOnInit: accountingNature: ', this.incomingMonitorFilter.accountingNature);
    // this.merchantList = this.service.getMerchants();
    // this.merchantSelected = 'Todas';
    // this.ngForm.get('album').patchValue(this.albums[0].id);
  }

  onLastTxnMonitor() {
    this.parent.showFilter = false;
    console.log('MonitorFilterComponent: onLastTxnMonitor: merchantId: ', this.incomingMonitorFilter.merchantId);
    console.log('MonitorFilterComponent: onLastTxnMonitor: status: ', this.incomingMonitorFilter.status);
    console.log(
      'MonitorFilterComponent: onLastTxnMonitor: accountingNature: ',
      this.incomingMonitorFilter.accountingNature
    );
    this.txnMonitorFilter.emit(this.incomingMonitorFilter);

    // this.txnMerchantSelected.emit(this.txnMonitorFilter);
    // this.txnStatusSelected.emit(this.statusSelected);
    // this.txnAccountingNature.emit(this.accountingNature);
  }

  cancelTxnMonitorFilter() {
    this.parent.showFilter = false;
  }

  // public spinner(): void {
  //   this.spinnerService.show();
  //   setTimeout(() => {
  //     this.spinnerService.hide();
  //   }, 300);
  // }

  ngOnDestroy() {}
}
